document.querySelector('buy-buttons .button[type="submit"]').textContent = "PRE ORDER";

const singleVariants = {
    "tusk-ceylon-grove": "sku-ceylon",
    "burmese-santal": "sku-burmese",
    "sangha-canopy": "sku-sangha",
    "uhuru-frost": "sku-uhuru",
    "tsavo-dawn": "sku-tsavo",
    "aberdare-pine": "sku-aberdare",

};

const varietPacks = {
    "alpine-dawn-trio": "sku-alpine",
    "midnight-canopy-trio": "sku-midnight",
    "heirloom-apothecary-trio": "sku-heirloom",
    "lush-costal-trio": "sku-lush",
    "custom-bar-soap-3-pack": "sku-threePack",
    "tusk-reserve-complete-soap-6-pack": "sku-sixPack"
};

const soapIngredients = {
    "Ceylon-Grove": "Sodium Tallowate, Sodium Palm Kernelate, Water, Glycerin, Natural Fragrance, Titanium Dioxide, Sodium Chloride, Citric Acid, Cocos Nucifera (Coconut) Oil, Hypnea Musciformis (Red Seaweed) Extract, Gelidiella Acerosa (Red Algae) Extract, Sargassum Filipendula (Brown Seaweed) Extract, Sorbitol, Tocopheryl Acetate, Calophyllum Inophyllum (Tamanu) Seed Oil, Paullinia Cupana (Guarana) Seed Extract, Ultramarines (CI 77007), Iron Oxides (CI 77492), Spirulina Platensis (Blue Green Algae) Powder.",
    "Burmese-Santal": "Sodium Palmate, Sodium Cocoate, Water, Glycerin, Natural Fragrance, Sodium Chloride, Citric Acid, Cannabis Sativa (Hemp) Seed Oil, Volcanic Pumice, Aloe Barbadensis Leaf Juice, Charcoal Powder, Caffeine.",
    "Sangha-Canopy": "Sodium Tallowate, Sodium Palm Kernelate, Water, Glycerin, Natural Fragrance, Sodium Chloride, Butyrospermum Parkii (Shea) Butter, Theobroma Cacao (Cocoa) Seed Butter, Citric Acid, Ultramarines (CI 77007), Iron Oxides (CI 77492), Charcoal Powder, Zingiber Officinale (Ginger) Root Extract, Daemonorops Draco Resin (Dragon’s Blood) Extract, Aquilaria Agallocha (Oud) Wood Oil.",
    "Uhuru-Frost": "Sodium Tallowate, Sodium Palm Kernelate, Water, Glycerin, Sodium Chloride, Natural Fragrance, Eucalyptus Globulus (Eucalyptus) Leaf Oil, Mentha Piperita (Peppermint) Oil, Menthol, Melaleuca Alternifolia (Tea Tree) Leaf Oil, Rosmarinus Officinalis (Rosemary) Leaf Oil, Menthyl Lactate, Hamamelis Virginiana (Witch Hazel) Water.",
    "Tsavo-Dawn": "Sodium Tallowate, Sodium Palm Kernelate, Water, Glycerin, Sodium Chloride, Natural Fragrance, Coffea Arabica (Coffee) Seed Powder, Caffeine, Butyrospermum Parkii (Shea) Butter, Theobroma Cacao Seed Butter, Zinc Oxide.",
    "Aberdare-Pine": "Sodium Tallowate, Sodium Palm Kernelate, Water, Glycerin, Sodium Chloride, Natural Fragrance, Pinus Palustris Wood (Pine) Tar, Kaolin (Clay), Charcoal Powder, Bambusa Arundinacea (Bamboo) Stem Powder, Melaleuca Alternifolia Leaf (Tea Tree) Oil, Abies Sibirica (Siberian Fir) Oil, Bambusa Arundinacea (Bamboo) Stem Powder, Tocopheryl Acetate (Vitamin E)."
};

const products = {...singleVariants, ...varietPacks};

const currentUrl = window.location.href;

Object.entries(products).forEach(([slug, sku]) => {
    if (currentUrl.includes(`products/${slug}`)) {

        if (varietPacks[slug]) {
            document.getElementById('varietyPacks').classList.add('active');
            document.getElementById('varietyPacksTab').classList.add('active');
        }else{
            document.getElementById('singlePack').classList.add('active');
            document.getElementById('singlePackTab').classList.add('active');
        }

        document.body.classList.add(sku);

        const scentLinks = document.querySelectorAll(".soap-content.active .soap-item");
        scentLinks.forEach(link => {
            if (link.dataset.title === sku) {
                link.classList.add("active");
            }
        });

        document.querySelector(".product-gallery-card.dt-fcard").classList.add(sku.replace("sku-", ""));

        let tallowBarLabel;
        let scentInfo;
        let soapTitle;
        let scentLabel;
        let location;
        let weight = "NET WT. 7 oz • 198 g";
        let atmosphere;
        let scentMoodHeadline;
        let scentMoodDescription;
        let mapImageUrl;
        let ingredients;

        switch (sku) {
            case "sku-ceylon":
                soapTitle = "Ceylon Grove 53";
                tallowBarLabel = "Exfoliating Tallow Bar";
                scentInfo = "Tropical Dew";
                scentLabel = "SCENT NO. 53";
                location = "Coastal lowlands of Sri Lanka (Ceylon) ";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/ceylon-map.webp?v=1780440053";
                scentMoodHeadline = "Warm Breeze. Coastal Dew.";
                scentMoodDescription = "A restorative blend of tropical dew, sea kelp, and sweet tamanu seed that channels the lush, vibrant coasts of a thriving island reserve.";
                ingredients = ["Ceylon-Grove"];
                break;
            case "sku-burmese":
                soapTitle = "Burmese Santal 47";
                tallowBarLabel = "Exfoliating Volcanic Pumice Body Bar";
                scentInfo = "Exotic Sandalwood";
                scentLabel = "SCENT NO. 47";
                location = "The wild jungles of Myanmar (Burma) ";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/burmese-map.webp?v=1780440053";
                scentMoodHeadline = "Dense Canopy. Wild Earth.";
                scentMoodDescription = "Intoxicating exotic sandalwood and dark charcoal transport you deep into the heart of historic, untamed jungle terrain.";
                ingredients = ["Burmese-Santal"];

                document.querySelector(".dt-formula-item.tallow").style.display = "none";
                document.querySelector(".dt-formula-item.pumice").style.display = "block";
                break;
            case "sku-sangha":
                soapTitle = "Sangha Canopy 71";
                tallowBarLabel = "Invigorating Tallow Bar";
                scentInfo = "Rainforest Canopy";
                scentLabel = "SCENT NO. 71";
                location = "Sangha Trinational, Congo Basin ";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/sangha-map.webp?v=1780440054";
                scentMoodHeadline = "Deep Jungle. Rich Resin.";
                scentMoodDescription = "Dark oud wood, wild ginger, and rare dragon’s blood resin capture the intense, beating heart of the equatorial rainforest.";
                ingredients = ["Sangha-Canopy"];
                break;
            case "sku-uhuru":
                soapTitle = "Uhuru Frost 61";
                tallowBarLabel = "Inivgorating & Refreshing Tallow Bar";
                scentInfo = "Eucalyptus Mint with Menthol";
                scentLabel = "SCENT NO. 61";
                location = "Uhuru Peak, Mt. Kilimanjaro, Tanzania ";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/uhuru-map.webp?v=1780440053";
                scentMoodHeadline = "Glacial Ice. Alpine Clarity.";
                scentMoodDescription = "Crisp eucalyptus, crushed peppermint, and icy menthol deliver the sharp, breathtaking chill of a high-altitude summit.";
                ingredients = ["Uhuru-Frost"];
                break;
            case "sku-tsavo":
                soapTitle = "Tsavo Dawn 81";
                tallowBarLabel = "Exfoliating Tallow Bar";
                scentInfo = "Old Books & Oak";
                scentLabel = "SCENT NO. 81";
                location = "Tsavo National Park, Kenya ";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/tsavo-map.webp?v=1780440053";
                scentMoodHeadline = "Sunbaked Earth. Vintage Oak.";
                scentMoodDescription = "Aged oak, vintage parchment, and crushed coffee bean evoke the legendary, red-dirt savannas warming under the early morning sun.";
                ingredients = ["Tsavo-Dawn"];
                break;
            case "sku-aberdare":
                soapTitle = "Aberdare Pine 39";
                tallowBarLabel = "Exfoliating Tallow Bar";
                scentInfo = "Siberian Fir & Pine Tar";
                scentLabel = "SCENT NO. 39";
                location = "Aberdare National Park, Kenya ";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/aberdare-map.webp?v=1780440053";
                scentMoodHeadline = "Deep Woods. Crisp Air.";
                scentMoodDescription = "Raw pine tar and Siberian fir evoke the rugged, misty highlands and ancient, unyielding mountain forests.";
                ingredients = ["Aberdare-Pine"];
                break;

            // ############# VARIETY PACKS #################

            case "sku-alpine":
                soapTitle = "Alpine Dawn Trio";
                tallowBarLabel = "Curated Variety Pack";
                scentInfo = "Eucalyptus, Sunbaked Earth, Crisp Siberian Fir";
                scentLabel = "Expedition No. 184";
                weight = "Net Wt. 21 oz • 594 g";
                atmosphere = "The Crisp Air of Early Morning at High-Altitude";
                location = "Uhuru Peak, Mt. Kilimanjaro, Tanzania; Tsavo National Park, Kenya; Aberdare National Park, Kenya";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Vanguard_Expedition.webp?v=1780677696";
                scentMoodHeadline = "Crisp Altitude. Raw Clarity.";
                scentMoodDescription = "A highly stimulating collision of icy alpine menthol, crushed coffee bean, and crisp Siberian fir engineered to clear the mind and breathe in the early morning ascent.";
                ingredients = ['Uhuru-Frost','Tsavo-Dawn', 'Aberdare-Pine'];
                break;
            case "sku-midnight":
                soapTitle = "Midnight Canopy Trio";
                tallowBarLabel = "Curated Variety Pack";
                scentInfo = "Woody Forest, Deep, Grounding";
                scentLabel = "Expedition No. 157";
                weight = "Net Wt. 21 oz • 594 g";
                atmosphere = "A Grounded Evening Campfire Deep in the Forest";
                location = "Aberdare National Park, Kenya; The wild jungles of Myanmar (Burma); Sangha Trinational, Congo Basin";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Campfile_in_Woods.webp?v=1780677696";
                scentMoodHeadline = "Deep Woods. Ancient Earth.";
                scentMoodDescription = "An immersive collection of rare oud wood, raw pine tar, and exotic sandalwood that evokes the quiet, enduring strength of an evening campfire deep in the forest.";
                ingredients = ['Burmese-Santal','Sangha-Canopy', 'Aberdare-Pine'];
                break;
            case "sku-heirloom":
                soapTitle = "Heirloom Apothecary Trio";
                tallowBarLabel = "Curated Variety Pack";
                scentInfo = "Vintage Oak, Sandalwood, Oud";
                scentLabel = "Expedition No. 199";
                weight = "Net Wt. 21 oz • 594 g";
                atmosphere = "The Sovereign Explorer's Field Study";
                location = "Tsavo National Park, Kenya; Sangha Trinational, Congo Basin; The wild jungles of Myanmar (Burma)";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Heritage_Explorers_Site.webp?v=1780678001";
                scentMoodHeadline = "Aged Oak. Rare Resins.";
                scentMoodDescription = "A sophisticated gathering of vintage parchment, rich dragon's blood resin, and exotic sandalwood that transports you to the quiet refinement of a sovereign explorer's field study.";
                ingredients = ['Burmese-Santal','Sangha-Canopy', 'Tsavo-Dawn'];
                break;
            case "sku-lush":
                soapTitle = "Lush Costal Trio";
                tallowBarLabel = "Curated Variety Pack";
                scentInfo = "Fresh, Green, Aquatic Botanicals";
                scentLabel = "Expedition No. 153";
                weight = "Net Wt. 21 oz • 594 g";
                atmosphere = "A Lush, Costal & Restorative Retreat";
                location = "Coastal lowlands of Sri Lanka (Ceylon); The wild jungles of Myanmar (Burma)";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Lush_Costal_Retreat.webp?v=1780677696";
                scentMoodHeadline = "Lush Canopy. Costal Dew.";
                scentMoodDescription = " A deeply restorative retreat blending mineral-rich sea kelp, wild hemp, and tropical dew to channel the warm, breathing coasts of the equatorial reserve.";
                ingredients = ['Ceylon-Grove','Burmese-Santal'];
                break;
            case "sku-threePack":
                soapTitle = "Custom Bar Soap 3 Pack";
                tallowBarLabel = "Personal Variety Pack";
                scentInfo = "Custom Curated Aromatics";
                scentLabel = "Choose Your Expedition";
                weight = "Net Wt. 21 oz • 594 g";
                atmosphere = "Bespoke Expedition Tailored to Your Day";
                location = "A custom itinerary across our Global Reserve Network";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/Tusk_Website_Line_Art_Variety_Pack_Images_Choose_Your_Journey_Mountain.webp?v=1780677696";
                scentMoodHeadline = "Sovereign Choice. Bespoke Ritual.";
                scentMoodDescription = "Total sovereign control over your daily provision. Select any three aromatics to build a custom olfactory expedition tailored exactly to your personal field requirements.";
                ingredients = ['Aberdare-Pine','Burmese-Santal','Ceylon-Grove','Sangha-Canopy','Tsavo-Dawn','Uhuru-Frost'];
                break;
            case "sku-sixPack":
                soapTitle = "Tusk Reserve Complete Soap 6 Pack";
                tallowBarLabel = "Curated Variety Pack";
                scentInfo = "The Entire Apothecary (Earth, Wood, Glacial, Tropic)";
                scentLabel = "Expedition No. 360";
                weight = "Net Wt. 42 oz • 1.18 kg";
                atmosphere = "The Ultimate Global Expedition";
                location = "Aberdare National Park, Kenya; The wild jungles of Myanmar (Burma); Coastal lowlands of Sri Lanka (Ceylon); Sangha Trinational, Congo Basin; Tsavo National Park, Kenya; Uhuru Peak, Mt. Kilimanjaro, Tanzania";
                mapImageUrl = "https://cdn.shopify.com/s/files/1/0035/7911/7681/files/tusk__Global_Expedition.webp?v=1780677683";
                scentMoodHeadline = "The Complete Apothecary. Global Terrain.";
                scentMoodDescription = "Experience the entirety of our global olfactory expedition. A masterful, unyielding collection spanning from the icy peaks of Kilimanjaro to the deep, resonant canopy of the Congo Basin.";
                ingredients = ['Aberdare-Pine','Burmese-Santal','Ceylon-Grove','Sangha-Canopy','Tsavo-Dawn','Uhuru-Frost'];
                break;
        }

        if (varietPacks[slug]) {
            document.querySelector(".dt-fcard-info .atm-label").textContent = "Atmosphere:";
            document.querySelector(".dt-fcard-info .scentInfo").textContent = atmosphere;


        }else{
            document.querySelector(".dt-fcard-info .atm-label").textContent = "Scent:";
            document.querySelector(".dt-fcard-info .scentInfo").textContent = scentInfo;
        }

        let IngredientsHtml = '';
        Object.entries(ingredients).forEach(([key, title]) => {
            IngredientsHtml += `<strong>${title.replaceAll('-',' ')}</strong> ${soapIngredients[title]}<br><br>`;
        });

        document.querySelector(".dt-faq-content.ingredient p").innerHTML = IngredientsHtml;
        document.querySelector(".tallow-bar-label").textContent = tallowBarLabel;
        document.querySelector(".dt-fcard-content .subhead").textContent = tallowBarLabel;
        document.querySelector(".dt-fcard-content .scent").textContent = scentLabel;
        document.querySelector(".dt-fcard-content .weight").textContent = weight;
        document.querySelector(".dt-soap-product-strip-inner p").textContent = weight;
        document.querySelector(".scent-info-bar span").textContent = scentInfo;
        document.querySelector(".dt-fcard-info .location").textContent = location;
        document.querySelector(".dt-soap-note-illustration img").setAttribute("src", mapImageUrl);
        document.querySelector(".dt-soap-product-strip-inner span.soap-title").textContent = soapTitle;
        document.querySelector(".dt-soap-product-strip-inner span.soap-type").textContent = tallowBarLabel;
        document.querySelector(".dt-soap-note-card.scent-mood h3").textContent = scentMoodHeadline;
        document.querySelector(".dt-soap-note-card.scent-mood p.description").textContent = scentMoodDescription;
    }
});